<template>
  <div v-if="isDataLoaded">
    <div class="full-width">
      <p class="card-title">
        {{ getString('module.stats.requests') }}
      </p>
      <div class="card-block">
        <line-chart
          v-show="dataReady"
          :chartData="data"
          :options="options"
          :height="220"
          :ref="component"
        />
        <div class="row" v-for="(legend, index) in data.legends" :key="index">
          <!-- Legends -->
          <div
            class="row legend q-ml-md q-mt-md q-mb-sm"
            :class="{
              'text-hidden': data.datasets[index].hidden,
            }"
            @click="toggleData(index)"
          >
            <div :class="legend.color"></div>
            <span>{{ legend.label }}</span>
          </div>
          <div
            class="col q-mr-md q-mt-sm"
            style="display: flex; justify-content: right"
          >
            <div class="legend-text">
              {{ getString('module.dashboard.stats.total') }}:
              <b>{{ data.totalAmounts[index] }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'requests',
      data: {
        labels: [],
        totalAmounts: [],
        datasets: [
          this.initDataset(this.getColor('blue')),
          this.initDataset(this.getColor('purple')),
          this.initDataset(this.getColor('red')),
        ],
        legends: [
          {
            color: 'blue',
            label: this.getString('module.stats.bussiness-email'),
          },
          {
            color: 'purple',
            label: this.getString('module.stats.existing-account'),
          },
          {
            color: 'red',
            label: this.getString('module.stats.new-account'),
          },
        ],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const stats = this.statisticData;
      this.data.datasets[0].data = stats.period.map(x => x.businessEmail * 1);
      this.data.datasets[1].data = stats.period.map(
        x => x.existingAccount * 1,
      );
      this.data.datasets[2].data = stats.period.map(x => x.newAccount * 1);
      this.data.totalAmounts[0] = stats.total.businessEmail || 0;
      this.data.totalAmounts[1] = stats.total.existingAccount || 0;
      this.data.totalAmounts[2] = stats.total.newAccount || 0;
      this.dataReady = true;
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
